import Color from 'color';

export default function colorToHex(rgba: any) {
  const color = new Color(rgba);

  return color.hex();
}
